import React from "react";
import { useTranslation } from "react-i18next";
import { Handle } from "@xyflow/react";

// MUI
import Typography from "@mui/material/Typography";

// Components
import Progress from "../../../../components/progress";

// Styles
import styles from "./unitNode.module.scss";

const UnitNode = ({ data }) => {
  const { t } = useTranslation();

  return (
    <div id={data.id} className={styles.unitNode}>
      <div className="flex flex-row items-center justify-between w-full">
        <Typography variant="body2" color="textPrimary" className={styles.unitNodeLabel}>
          {t('masteryMap.unit_label', { index: data.index + 1 })}
        </Typography>

        <div className={`${styles.unitNodeProgressContainer} flex-1`}>
          <Typography variant="body2" className={styles.unitNodeProgressText}>
            {data.progress}%
          </Typography>

          <Progress progress={data.progress} classes={{ progressBar: styles.unitNodeProgressBar }} />
        </div>
      </div>

      <Typography variant="body2" color="textSecondary" className={styles.unitNodeLabel}>
        {data.title}
      </Typography>

      <Handle type="source" position="right" style={{ opacity: 0, pointerEvents: 'none' }} />
      <Handle type="target" position="left" style={{ opacity: 0, pointerEvents: 'none' }} />
    </div>
  )
}

export default UnitNode;
